"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _player = _interopRequireDefault(require("@vimeo/player"));

var _hls = _interopRequireDefault(require("hls.js"));

var SearchPanel = /*#__PURE__*/function () {
  function SearchPanel(component) {
    (0, _classCallCheck2["default"])(this, SearchPanel);
    this.dom = {
      $component: component,
      $play: component.querySelector('.js-video-section-play'),
      $container: component.querySelector('.VideoSection__container'),
      $player: component.querySelector('.VideoSection__container .VideoSection__video iframe'),
      $overlayPlayer: component.querySelector('.VideoSection__container .VideoSection__videoHLS-overlay')
    }, this.state = {
      open: false,
      player: false
    };
    this.playerHandler = this.play.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(SearchPanel, [{
    key: "mount",
    value: function mount() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('VideoSection : mount', this);

      if (dom.$play) {
        dom.$play.addEventListener('click', this.playerHandler);
        state.player = new _player["default"](dom.$player);

        if (dom.$overlayPlayer) {
          this.initVideo();
        }
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var self = this;
      var dom = this.dom;
      console.log('VideoSection : unmount', this);

      if (dom.$play) {
        dom.$play.removeEventListener('click', this.playerHandler);
      }
    }
  }, {
    key: "play",
    value: function play(event) {
      var dom = this.dom,
          state = this.state;
      console.log('VideoSection : toggle', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      dom.$container.classList.add('VideoSection__container-active');
      state.player.play();
    }
  }, {
    key: "initVideo",
    value: function initVideo() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('HPVideo : initVideo', this);

      if (dom.$overlayPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        // Some browers (safari and ie edge) support HLS natively
        dom.$overlayPlayer.src = dom.$overlayPlayer.getAttribute('data-src');
      } else if (_hls["default"].isSupported()) {
        var hls = new _hls["default"]();
        hls.loadSource(dom.$overlayPlayer.getAttribute('data-src'));
        hls.attachMedia(dom.$overlayPlayer);
      } else {
        console.error("This is a legacy browser that doesn't support MSE");
      }
    }
  }]);
  return SearchPanel;
}();

exports["default"] = SearchPanel;